import { render, staticRenderFns } from "./AudioAnswer.vue?vue&type=template&id=7e8e650a&scoped=true&"
import script from "./AudioAnswer.vue?vue&type=script&lang=js&"
export * from "./AudioAnswer.vue?vue&type=script&lang=js&"
import style0 from "./AudioAnswer.vue?vue&type=style&index=0&id=7e8e650a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e8e650a",
  null
  
)

export default component.exports